// src/services/partnerService.js
const BASE_URL = "https://user.globtel.biz/api/";
const DEV_URL = "http://10.40.1.69:8000";
const TIMEOUT_MS = 10000;

export function buildPartnerRegisterUrl({
  company,
  address,
  sector,
  email,
  username,
  registration_number,
  country,
  phone_number,
}) {
  const url = new URL("partner/register", BASE_URL);
  url.searchParams.set("company", company || "");
  url.searchParams.set("address", address || "");
  url.searchParams.set("sector", sector || "");
  url.searchParams.set("email", email || "");
  url.searchParams.set("username", username || "");
  url.searchParams.set("registration_number", registration_number || "");
  url.searchParams.set("country", country || "");
  url.searchParams.set("phone_number", phone_number || "");
  return url.toString();
}

export async function registerPartner({
  company,
  address,
  sector,
  email,
  username,
  registration_number,
  country,
  phone_number,
  receive_special_deals,
}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);

  try {
    const res = await fetch(`${DEV_URL}/partner/register`, {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      signal: controller.signal,
      body: JSON.stringify({
        company,
        address,
        sector,
        email,
        username,
        registration_number,
        country,
        phone_number,
        receive_special_deals,
      }),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Register partner failed: ${res.status} ${text}`);
    }

    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) {
      return await res.json();
    }
    return { ok: true };
  } finally {
    clearTimeout(timer);
  }
}
